import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  TopToolbar,
  EditButton,
  Button,
  ReferenceManyField,
  Datagrid,
  FunctionField,
  BooleanField,
  useRecordContext,
  useRedirect,
} from "react-admin";
import type { RaRecord, ShowProps } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Typography } from "@mui/material";
import { formatINR } from "@/utils";
import { openProjectTakhmeenReceiptPrint } from "@/containers/projects/project-takhmeen-receipts/project-takhmeen-receipt-utils";
import { computeProjectTakhmeenPending } from "./project-takhmeen-display";

const ReceiptToolbar = () => {
  const record = useRecordContext();
  const redirect = useRedirect();
  if (!record?.id) return null;
  return (
    <TopToolbar>
      <EditButton />
      <Button
        label="Add receipt"
        onClick={() => redirect(`/projectTakhmeenReceipts/create?projectTakhmeenId=${record.id}`)}
      />
    </TopToolbar>
  );
};

export const ProjectTakhmeenShow = (props: ShowProps) => (
  <Show {...props} actions={<ReceiptToolbar />}>
    <SimpleShowLayout>
      <TextField source="itsNo" label="ITS" />
      <TextField source="memberName" emptyText="—" />
      <NumberField source="units" />
      <NumberField source="committedAmount" options={{ style: "currency", currency: "INR" }} />
      <NumberField source="paidAmount" options={{ style: "currency", currency: "INR" }} />
      <FunctionField
        label="Pending balance"
        render={(record: RaRecord) =>
          formatINR(computeProjectTakhmeenPending(record), { empty: "—" })
        }
      />
      <BooleanField
        source="isAmountOverridden"
        label="Amount overridden"
        valueLabelTrue="Yes"
        valueLabelFalse="No"
      />
      <TextField source="remarks" emptyText="—" />
      <DisplayDateField source="updatedAt" showTime emptyText="—" />
    </SimpleShowLayout>
    <Box sx={{ px: 2, pb: 2 }}>
      <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }} fontWeight={600}>
        Receipts
      </Typography>
      <ReferenceManyField
        reference="projectTakhmeenReceipts"
        target="projectTakhmeenId"
        label={false}
      >
        <Datagrid bulkActionButtons={false} rowClick="show">
          <TextField source="receiptNo" emptyText="—" />
          <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
          <TextField source="paymentMode" />
          <DisplayDateField source="receiptDate" emptyText="—" />
          <FunctionField
            label="Print"
            render={(rec: RaRecord) => (
              <Button
                label="Print"
                onClick={(e) => {
                  e.stopPropagation();
                  openProjectTakhmeenReceiptPrint(rec.id);
                }}
              >
                <DownloadIcon />
              </Button>
            )}
          />
        </Datagrid>
      </ReferenceManyField>
    </Box>
  </Show>
);
